(ns app.domain.building-code.model
  (:require [app.domain.inspection.model :as inspection-model]
            [clojure.string :as str]))

(def ai-request-limit 2048)

(def reference-types
  {"bc"       {:label       "BC"
               :parts-count 10
               :corpus-ids  ["ca-bc-bcbc-2024-2024-07-04"]}
   "obc"      {:label       "OBC"
               :parts-count 12
               :corpus-ids  ["ca-on-obc-2024-2025-01-16-volume-1"
                             "ca-on-obc-2024-2025-01-16-volume-2"]}
   "nbc"      {:label       "NBC (2020)"
               :parts-count 9
               :corpus-ids  ["ca-nbc-2020"]}
   "nbc_2025" {:label       "NBC (2025)"
               :parts-count 10
               :corpus-ids  ["ca-nbc-2025"]}})

(defn subdivision-key->reference-type [subdivision-key]
  (when (str/starts-with? (name subdivision-key) "CA-") ;; Currently only used in Canada.
    (case subdivision-key
      :CA-ON "obc"
      :CA-BC "bc"
      "nbc_2025")))

(defn inspection-reference-type [inspection]
  (-> inspection
      inspection-model/workspace
      :workspace/municipality
      :municipality/subdivision
      subdivision-key->reference-type))
